import { HttpWorkspaceAdapter, type HttpWorkspaceAdapterOptions } from './HttpWorkspaceAdapter'
import { IndexedDbWorkspaceAdapter } from './IndexedDbWorkspaceAdapter'
import { InMemoryWorkspaceAdapter } from './InMemoryWorkspaceAdapter'
import type { WorkspaceRepository } from './WorkspaceRepository'

export type WorkspacePersistenceMode = 'browser' | 'mysql'

export interface CreateWorkspaceRepositoryOptions {
  mode?: WorkspacePersistenceMode
  http?: HttpWorkspaceAdapterOptions
}

export function readWorkspacePersistenceMode(value = import.meta.env?.VITE_OPENELP_WORKSPACE_MODE): WorkspacePersistenceMode {
  const mode = value?.trim() || 'browser'
  if (mode !== 'browser' && mode !== 'mysql') {
    throw new Error(`Unsupported VITE_OPENELP_WORKSPACE_MODE: ${mode}`)
  }
  return mode
}

export function createWorkspaceRepository(options: CreateWorkspaceRepositoryOptions = {}): WorkspaceRepository {
  const mode = options.mode ?? readWorkspacePersistenceMode()
  if (mode === 'mysql') return new HttpWorkspaceAdapter(options.http)
  return typeof indexedDB === 'undefined'
    ? new InMemoryWorkspaceAdapter()
    : new IndexedDbWorkspaceAdapter()
}
